export const LOCALSTORAGE_KEY = 'USER_INFO';